import client from '../../common/client';

export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const VIDEO_PROGRESS = 'VIDEO_PROGRESS';
export const COMPLETE_VIDEO = 'COMPLETE_VIDEO';
export const GET_TATHATA_FOLLOW_UP_DATA = 'GET_TATHATA_FOLLOW_UP_DATA';
export const UPDATE_SOURCE = 'UPDATE_SOURCE';

export const createSubscription = (userId, source, plan) => {
  const payload = {
    source,
    plan,
  };

  if (window.tap && window.tap.vid) {
    payload.tapfiliateVid = window.tap.vid;
  }

  return {
    promise: client.post(`users/${userId}/subscriptions`, payload),
    type: CREATE_SUBSCRIPTION,
  };
};

export const updateSubscription = (userId, subscriptionId, source, plan) => {
  const payload = { plan };

  if (source) {
    payload.source = source;
  }

  payload.cancel_at_period_end = false;

  return {
    promise: client.patch(`users/${userId}/subscriptions/${subscriptionId}`, payload),
    type: UPDATE_SUBSCRIPTION,
    subscriptionId,
  };
};

export const updateSource = (userId, source) => ({
  promise: client.put(`users/${userId}/stripe-source`, { source }),
  type: UPDATE_SOURCE,
});

export const cancelSubscription = (userId, subscriptionId) => ({
  promise: client.delete(`users/${userId}/subscriptions/${subscriptionId}`),
  type: CANCEL_SUBSCRIPTION,
  subscriptionId,
});

export const videoProgress = (videoId, progress) => ({
  promise: client.post(`videos/${videoId}/progress`, { progress }),
  type: VIDEO_PROGRESS,
  progress,
  videoId,
});

export const completeVideo = videoId => ({
  promise: client.post(`progress/videos`, { id: videoId }),
  type: COMPLETE_VIDEO,
  videoId,
});

export function getTathataFollowUpData() {
  return {
    type: GET_TATHATA_FOLLOW_UP_DATA,
    promise: client.get('sessions/data'),
  };
}



// WEBPACK FOOTER //
// ./src/subscription/redux/actions.js